import React from "react";

export const ServicesLogo = ({ classNames, color }) => {
  return (
    <div className={`${classNames}`}>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.375 7.625H5.875C6.8375 7.625 7.625 6.8375 7.625 5.875V2.375C7.625 1.4125 6.8375 0.625 5.875 0.625H2.375C1.4125 0.625 0.625 1.4125 0.625 2.375V5.875C0.625 6.8375 1.4125 7.625 2.375 7.625Z"
          fill={`${color}`}
        />
        <path
          d="M2.375 16.375H5.875C6.8375 16.375 7.625 15.5875 7.625 14.625V11.125C7.625 10.1625 6.8375 9.375 5.875 9.375H2.375C1.4125 9.375 0.625 10.1625 0.625 11.125V14.625C0.625 15.5875 1.4125 16.375 2.375 16.375Z"
          fill={`${color}`}
        />
        <path
          d="M9.375 2.375V5.875C9.375 6.8375 10.1625 7.625 11.125 7.625H14.625C15.5875 7.625 16.375 6.8375 16.375 5.875V2.375C16.375 1.4125 15.5875 0.625 14.625 0.625H11.125C10.1625 0.625 9.375 1.4125 9.375 2.375Z"
          fill={`${color}`}
        />
        <path
          d="M11.125 16.375H14.625C15.5875 16.375 16.375 15.5875 16.375 14.625V11.125C16.375 10.1625 15.5875 9.375 14.625 9.375H11.125C10.1625 9.375 9.375 10.1625 9.375 11.125V14.625C9.375 15.5875 10.1625 16.375 11.125 16.375Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
};
